export default __webpack_public_path__ + "static/media/Fin-tech-onboarding.31eeb645.png";